import type { FC } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import AkLozenge from '@atlaskit/lozenge';
import AkTooltip from '@atlaskit/tooltip/Tooltip';

import type { LozengeProps } from './types.ts';

const i18n = defineMessages({
	externalUserLozengeText: {
		id: 'external-collab-ui.user-guest-lozenge',
		defaultMessage: 'Guest',
		description: 'Text for a lozenge showing that a user is a guest in Confluence',
	},
	guestUserTooltip: {
		id: 'external-collab-ui.user-guest-lozenge.tooltip',
		defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
		description: 'Tooltip text for lozenge showing that a user is a guest in Confluence',
	},
});

export const ExternalUserLozengeProps: LozengeProps = {
	text: (
		<AkTooltip content={<FormattedMessage {...i18n.guestUserTooltip} />}>
			<FormattedMessage {...i18n.externalUserLozengeText} />
		</AkTooltip>
	),
	appearance: 'default',
	isBold: false,
};

export const ExternalUserLozenge: FC = () => {
	const { text, appearance, isBold } = ExternalUserLozengeProps;
	return (
		<AkLozenge appearance={appearance} isBold={isBold}>
			{text}
		</AkLozenge>
	);
};
